import { render, staticRenderFns } from "./UsageTab.vue?vue&type=template&id=c3352f16&"
import script from "./UsageTab.vue?vue&type=script&lang=js&"
export * from "./UsageTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports